import {
  DELETE_DOCUMENT_FILE_URL,
  GET_DOCUMENT_FILE_URL,
  GET_LIST_DOCUMENTS_URL,
  POST_DOCUMENT_APPROVEMENT_URL,
  PUT_DOCUMENT_FILE_URL
} from 'enums/URLS/urlsApiDocumentos'
import { api_documentos } from 'services/apis'
import {
  DeleteDocumentApprovalFileParams,
  ListDocumentType,
  PostIncludeParams,
  ReponseGetDocumentApprovalFile,
  ReponsePostIncludeDocument,
  getDocumentApprovalFileParams,
  putDocumentApprovalParams
} from 'types/documentos'

export const getListDocuments = async (filtro: string) => {
  const FILTER = filtro ? `?${filtro}` : ''
  const response = await api_documentos.get(GET_LIST_DOCUMENTS_URL + FILTER)
  const data = response.data.data
  return data as ListDocumentType[]
}

export const postIncludeDocument = async ({
  documentToUpload,
  onUploadProgress
}: PostIncludeParams) => {
  const response = await api_documentos.post(POST_DOCUMENT_APPROVEMENT_URL, documentToUpload, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    onUploadProgress
  })
  const data = response.data.data
  return data as ReponsePostIncludeDocument
}

export const getDocumentApprovalFile = async ({
  id_corcc080,
  id_documento
}: getDocumentApprovalFileParams) => {
  const response = await api_documentos.get(GET_DOCUMENT_FILE_URL({ id_corcc080, id_documento }))
  const data = response.data.data
  return data as ReponseGetDocumentApprovalFile
}

export const deleteDocumentApprovalFile = async ({
  id_corcc080,
  id_documento
}: DeleteDocumentApprovalFileParams) => {
  const response = await api_documentos.delete(
    DELETE_DOCUMENT_FILE_URL({ id_corcc080, id_documento })
  )
  const data = response.data.data
  return data
}

export const putDocumentApproval = async (params: putDocumentApprovalParams[]) => {
  const response = await api_documentos.put(PUT_DOCUMENT_FILE_URL, params)
  return response.data.data
}
